import React, { useEffect, useState } from 'react';

import { Box, Button, downloadBlob, Loader, Modal } from '@qwealth/qcore';
import { getFile } from '@qwealth/qvault';

import TransitionBox from 'components/Households/Common/QNotes/TransitionBox';
import { fileExtensionToMimeMap } from 'data/refData/kyp';

interface DocumentPreviewModalProps {
  modalTitle: string;
  url: string;
  fileName: string;
  type: string;
  show: boolean;
  onClose: () => void;
}

// ToDo: Make a single component for all document previews
const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = ({ modalTitle, url, fileName, type, show, onClose }) => {
  const [blobUrl, setBlobUrl] = useState<string>();
  const [isLoading, setIsloading] = useState<boolean>(false);
  const isImageFile = type === 'jpg' || type === 'jpeg' || type === 'png';

  const getDocument = async () => {
    setIsloading(true);
    const fileBlob = await getFile(url);
    // Need to use the appropriate mime type; e.g. application/pdf
    const blob = fileBlob?.slice(0, fileBlob?.size, fileExtensionToMimeMap[type]);
    const blobUrl = URL.createObjectURL(blob as Blob);
    setBlobUrl(blobUrl);
    setIsloading(false);
  };

  useEffect(() => {
    if (url !== '') {
      getDocument();
    }
  }, [url, fileName]);

  return (
    <Box>
      <Modal onClose={() => onClose()} show={show} title={modalTitle} size="xl">
        <Modal.Body>
          {isLoading ? (
            <Loader />
          ) : (
            <TransitionBox index={0} isVisible={true}>
              <Box width="100%" height="80vh" display="flex" justifyContent="center">
                {url !== '' && !isImageFile && <iframe src={blobUrl} width="100%" height="100%" style={{ border: 'none', objectFit: 'contain' }} />}

                {url !== '' && isImageFile && <img src={blobUrl} />}
              </Box>

              <Box display="flex" width="100%" justifyContent="right" marginTop="default">
                <Button variant="outline" onClick={() => downloadBlob(blobUrl, fileName)}>
                  Download
                </Button>
              </Box>
            </TransitionBox>
          )}
        </Modal.Body>
      </Modal>
    </Box>
  );
};

export default DocumentPreviewModal;
